import React from "react";
import { FaIcon } from '../../../shared/components'

const CategoryRow = ({
  category,
  isExpanded,
  onToggle,
  onEdit,
  onDelete,
  onCheckboxClick,
  draggableProps,
  dragHandleProps,
  innerRef,
  isDraggable,
  canDashboardItems,
}) => {
  const hasSubcategories = category.subcategories.length > 0;

  return (
    <tr className={`category-row hoverable-row ${isDraggable ? 'draggable-row' : ''}`} style={{ cursor: 'pointer' }} onClick={hasSubcategories ? onToggle : undefined} ref={innerRef} {...draggableProps} {...dragHandleProps}>
      <td>
        <div
          className={`icheckbox_square-orange icheck-item ${category.checked ? 'checked' : ''} ${category.default ? 'disabled' : ''}`}
          onClick={onCheckboxClick}
        >
          <input
            id={`checkbox${category.id}`}
            className="i-checks icheck-input"
            type="checkbox"
            checked={category.checked}
            readOnly
          />
        </div>
      </td>
      <td>
        {isDraggable && <i className="fa fa-bars drag_handle ui-sortable-handle add-margin-right-5"></i>}
        <span style={{ fontSize: 16 }}>{category.name.length > 60 ? category.name.slice(0, 60) + '…' : category.name} </span>
        {hasSubcategories && (
          <span style={{ fontSize: 14 }}>• {category.subcategories.length} {category.subcategories.length === 1 ? 'submenu' : 'submenus'}</span>
        )}
        {!category.system_field && canDashboardItems && (
          <span className="actions">
            <span> • </span>
            <a onClick={(e) => { e.stopPropagation(); onEdit(); }} className="edit-action add-margin-right-5">
              <FaIcon icon='edit' />
              {window.I18n.t('mobile_app_dashboard.menu.edit')}
            </a>
            {!category.default && (
              <>
                <span>• </span>
                <a onClick={(e) => { e.stopPropagation(); onDelete(); }} className="remove-action">
                  <FaIcon icon='trash-alt-o' />
                  {window.I18n.t('mobile_app_dashboard.menu.remove')}
                </a>
              </>
            )}
          </span>
        )}
      </td>
      <td>
        {hasSubcategories > 0 && (
          <span className={isExpanded ? "arrow arrow-up" : "arrow arrow-down"}></span>
        )}
      </td>
    </tr>
  );
};

export default CategoryRow;
